import { Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/API/api.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { TestDriveFormComponent } from '../test-drive-form/test-drive-form.component';
import { EventService } from 'src/app/services/Events/events.service';

@Component({
  selector: 'app-view-offers-popup',
  templateUrl: './view-offers-popup.component.html',
  styleUrls: ['./view-offers-popup.component.css'],
})
export class ViewOffersPopupComponent implements OnInit {
  offers: any;
  showMore: boolean = false;
  constructor(
    private modalController: ModalController,
    public globalService: GlobalService,
    private apiService: ApiService,
    private sanitizer: DomSanitizer,
    private events:EventService
  ) {}

  ngOnInit() {
    this.offers = this.globalService.selectedVariant?.offer;
  }

  testDrive() {

    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'cta_clicked_visualizer',
      eAct: 'test_drive',
    });

    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::InternalTestDrive',
      'test drive offer'
    );

    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::InternalTestDrive::Set_' + this.globalService.idea,
      'test drive offer::Set_' + this.globalService.idea
    );

    // let testDriveUrl = this.globalService.getTestDriveUrl();
    // this.apiService.visualizerAnalytics('test_drive');
    // window.open(testDriveUrl, '_parent');

    this.testDriveFormModal(true);
  }

  getResultantVariable(flag: boolean): string {
    const url = new URL(window.location.href);
    const hasCcTrue = url.searchParams.get('cc') === 'true';
    const result = window.location.href.includes('visualizer') && !hasCcTrue ? 'Offer' : 'Offer';
    return `${result}_${flag ? 'Button' : 'Nudges'}`;
  }

  async testDriveFormModal(flag: boolean = false) {
    this.events.publish("nudgeUpdate", {val:false})
    this.apiService.logGAEvent("uaevent", "Content", "TDF::Cust_Details", "TDForm_popup");
    const result = this.getResultantVariable(flag);
    this.apiService.logGAEvent("uaevent","Content","TDF::Cust_Details", `${'TDForm_popup'}_${result}`);
    const modal = await this.modalController.create({
      component: TestDriveFormComponent,
      componentProps: {
        contentData: {
          header: 'CONFIGURATOR_HEADER_MSG.HEADER',
          msgContent: 'CONFIGURATOR_HEADER_MSG.CONTENT',
        },
        type: 'old',
        value: flag 
      },
      backdropDismiss: false,
      cssClass: 'one3d-test-drive-modal ' + ' auto-height',
      animated: false,
    });

    await modal.present();
    const { data } = await modal.onDidDismiss();
}

  /**
   * return santized & secure string to render in innerhtml
   * @param text that needs to be sanitized
   * @returns
   */
  getSanitizedDynamicText(text): string {
    const sanitizedText = this.sanitizer.bypassSecurityTrustHtml(text);
    return this.sanitizer.sanitize(SecurityContext.HTML, sanitizedText);
  }

  closeOffersPopup() {
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click:View_Offers',
      'pop up close'
    );
    this.globalService.dismissModal();
  }
}
